export const expression = /[a-zA-ZÄÖÜäöüÉÈÀéèà©Ññçß]/g;

export default (value: string): string => value.replace(expression, '');
